import { PurchaseStateAndDelivery } from "@smartrr/shared/entities/PurchaseState";

export interface DeliveryId {
  cpsId: string;
  index: number;
}

export const getDeliveryId = (delivery: PurchaseStateAndDelivery): DeliveryId => {
  return {
    cpsId: delivery.purchaseState.id,
    index: delivery.indexFromNext,
  };
};
